// Entry point for the build script in your package.json
import "./controllers"
import * as bootstrap from "bootstrap"

// Initialize Bootstrap tooltips on page load
document.addEventListener("DOMContentLoaded", () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
})
